import { useCallback, useEffect, useState } from "react";
import NetworkApi from "../network/networkApi";
interface ContentData {
  result: any[];
  loading: boolean;
}
const useChemicalWarehouse = (
  page?: number,
  autoLoad: boolean = true
): [ContentData, () => void, any] => {
  const [filter, changeFilter] = useState<any>(
    autoLoad ? (typeof page === "number" ? { page } : {}) : null,
  );
  const [content, changeContent] = useState<ContentData>({
    loading: false,
    result: [],
  });
  useEffect(() => {
    if (filter !== null) {
      loadContent();
    }
  }, [filter]);
  const loadContent = useCallback(async () => {
    changeContent({
      ...content,
      loading: true,
    });
    let response = await NetworkApi.requestGet(
      "/api/warehouse/chemical/list",
      filter
    );
    changeContent({
      loading: false,
      result: Array.isArray(response.result) ? response.result : [],
    });
  }, [content, filter]);

  return [content, loadContent, changeFilter];
};
export default useChemicalWarehouse;
